module.exports = __webpack_public_path__ + "img/alipay.a21e47dd.png";